import { cn } from '@/lib/cn'

/**
 * The MailSmith hallmark: an "M" struck into a plate, like a maker's stamp.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('size-7 shrink-0', className)}>
      <rect
        x="1.5"
        y="1.5"
        width="29"
        height="29"
        rx="7"
        className="fill-[#1d2126] dark:fill-[#242a31]"
      />
      <rect
        x="3.5"
        y="3.5"
        width="25"
        height="25"
        rx="5"
        fill="none"
        stroke="#c9923a"
        strokeWidth="1.25"
      />
      <path
        d="M8.5 22V10.5l7.5 7 7.5-7V22"
        fill="none"
        stroke="#e9c27a"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Logo({ collapsed }: { collapsed?: boolean }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark />
      {!collapsed && <span className="type-display text-[1.0625rem] text-ink">MailSmith</span>}
    </span>
  )
}
